//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
import announcement from '~/components/market/announcement';
import comInfo from '~/components/market/company-info';
import hkChange from '~/components/market/hk-change';
import indexMarket from '~/components/market/index-market';
import marketRange from '~/components/market/market-range';
export default {
  components: {
    indexMarket,
    marketRange,
    hkChange,
    comInfo,
    announcement,
  },
  async asyncData({ error, $axios }) {
    try {
      const [indexMarket, hkChange, companySum, companyInfo] =
        await Promise.all([
          $axios(api.getIndexMarket()),
          $axios(api.getHKChange()),
          $axios(api.getCompanySum()),
          $axios(api.getCompanyInfo()),
        ]);
      return {
        indexMarket:
          indexMarket && indexMarket.result ? indexMarket.result : [],
        hkChange: hkChange && hkChange.result ? hkChange.result : [],
        companySum: companySum && companySum.result ? companySum.result : [],
        companyInfo:
          companyInfo && companyInfo.result ? companyInfo.result : [],
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      error({
        statusCode: 404,
        message: 'Post not Found',
      });
    }
  },
  head() {
    return {
      title: '格隆汇行情-财经市场交易行情',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            '格隆汇行情栏目想针对专家荐股,中概股名单、港股涨跌幅、成交额、成交量等作出了详细的介绍,格隆汇已成为国内权威的海外（尤其港股）投资研究交流平台.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: '专家荐股,中概股名单,网红概念股股票',
        },
      ],
    };
  },
  methods: {},
};
